/**
 * Deep clone of any object
 * @param object
 */
export function clone<T extends Object | Array<any>>(object: T): T {
  return JSON.parse(JSON.stringify(object));
}
